import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";
import { gridCellClass } from "./TireComparisonGrid";
import { selectPricingContext } from "./selectPricingContext";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
  partQuantity: CompareResults["partQuantity"];
};

export const Subtotal: FunctionComponent<ProductInfoProps> = ({
  part,
  partQuantity,
}) => {
  const { t } = useTranslation();
  const { subTotal } = selectPricingContext(partQuantity);
  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) ? (
        <PriceDisplay>{subTotal}</PriceDisplay>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};
